/**
 * 对 4 个字节字符进行解码（如 emoji 表情）
 * @param {String} str - 需要处理的字符串
 * @returns {String} - 处理后的字符串
 */
export function decodeUnicode(str: string): string {
  return str.replace(/\[u:(\d+)\]/g, (_: any, $2: number) => String.fromCodePoint($2));
}

/**
 * 对 4 个字节字符进行编码（如 emoji 表情）
 * @param {String} s - 需要处理的字符串
 * @returns {String} - 处理后的字符串
 */
export function encodeUnicode(s: string): string {
  return Array.from(s, c => ((c.codePointAt(0) as number) > 0xffff ? `[u:${c.codePointAt(0)}]` : c)).join('');
}
